module.exports = function() {

    let modalCheckInProgress = false;
    let hasModalBeenShown = false;
    const PRIVACY_CHECK_SESSION_KEY = 'privacy_me_checked_session_v2';

    window.checkPrivacyPolicyAcceptance = function() {
        checkPrivacyAcceptance();
    };

    function isUserLoggedIn() {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('user_id');
        const isLogged = !!(token && userId);
        return isLogged;
    }

    function getCurrentSessionSignature() {
        const token = localStorage.getItem('token') || '';
        const userId = localStorage.getItem('user_id') || '';
        if (!token || !userId) {
            return '';
        }
        return userId + '::' + token;
    }

    function hasCheckedCurrentSession() {
        const currentSession = getCurrentSessionSignature();
        if (!currentSession) {
            return false;
        }

        return localStorage.getItem(PRIVACY_CHECK_SESSION_KEY) === currentSession;
    }

    function markCurrentSessionAsChecked() {
        const currentSession = getCurrentSessionSignature();
        if (currentSession) {
            localStorage.setItem(PRIVACY_CHECK_SESSION_KEY, currentSession);
        }
    }

    function checkPrivacyAcceptance() {
        if (modalCheckInProgress) {
            return;
        }

        if (!isUserLoggedIn()) {
            return;
        }

        if (!$('#privacy-policy-modal').length) {
            return;
        }

        if (hasCheckedCurrentSession()) {
            return;
        }

        try {
            const regulationUrl = $('#privacy-policy-modal').data('regulation-url');
            if (regulationUrl) {
                try {
                    const current = new URL(window.location.href);
                    const reg = new URL(regulationUrl);
                    if (current.pathname === reg.pathname) {
                        return;
                    }
                } catch (e) {
                    if (window.location.href.indexOf(regulationUrl) === 0) {
                        return;
                    }
                }
            }
        } catch (e) {
            console.warn('Não foi possível verificar URL de regulamento:', e.message);
        }

        modalCheckInProgress = true;
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('user_id');

        $.ajax({
            url: api_url + "user/me",
            method: 'GET',
            timeout: 10000,
            headers: {
                'Authorization': 'Bearer ' + token
            },
            success: function(response) {
                const userAccepted = response.aceite || false;
                const userCreatedAt = response.date || response.created_at || null;

                const cutoff = new Date('2026-10-05T00:00:00');
                const now = new Date();
                if (now < cutoff) {
                    return;
                }

                if (userCreatedAt) {
                    try {
                        const createdDate = new Date(userCreatedAt);
                        if (createdDate > cutoff) {
                            markCurrentSessionAsChecked();
                            return;
                        }
                    } catch (e) {
                        console.warn('Não foi possível interpretar date do usuário:', e.message);
                    }
                }

                // Só marca a sessão como checada quando não há aceite pendente;
                // sem aceite, o modal volta a cada carregamento de página.
                if (userAccepted !== false) {
                    markCurrentSessionAsChecked();
                    return;
                }

                if (!hasModalBeenShown) {
                    hasModalBeenShown = true;
                    showPrivacyModal();
                }
            },
            error: function(xhr) {
                if (xhr.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user_id');
                    localStorage.removeItem(PRIVACY_CHECK_SESSION_KEY);
                }
            },
            complete: function() {
                modalCheckInProgress = false;
            }
        });
    }

    function showPrivacyModal() {
        if (!$('#privacy-policy-modal').length) {
            return;
        }

        $('.modal').not('#privacy-policy-modal').each(function() {
            try {
                $(this).modal('hide');
            } catch (e) {
                console.warn('Aviso ao fechar modal:', e.message);
            }
        });

        setTimeout(function() {
            $('.modal-backdrop').remove();

            try {
                $('#privacy-policy-modal')
                    .off('show.bs.modal.privacyBackdrop hidden.bs.modal.privacyBackdrop')
                    .on('show.bs.modal.privacyBackdrop', function() {
                        $('body').addClass('privacy-policy-modal-open');
                    })
                    .on('hidden.bs.modal.privacyBackdrop', function() {
                        $('body').removeClass('privacy-policy-modal-open');
                    });

                $('#privacy-policy-modal').modal({
                    backdrop: 'static',
                    keyboard: false,
                    show: true
                });

                $('#privacy-policy-modal').css('z-index', 9999);
                setTimeout(function() {
                    $('.modal-backdrop').css('z-index', 9998);
                }, 100);

                $('#acceptPrivacyCheckbox').off('change').on('change', function() {
                    $('#acceptPrivacyBtn').prop('disabled', !$(this).is(':checked'));
                });

                $('#acceptPrivacyBtn').off('click').on('click', function(e) {
                    e.preventDefault();

                    if (!$('#acceptPrivacyCheckbox').is(':checked')) {
                        return;
                    }

                    $('#privacy-loading').show();
                    $('#privacy-error').hide();
                    $(this).prop('disabled', true);

                    $.ajax({
                        url: api_url + 'user/accept-terms',
                        method: 'PUT',
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                        },
                        success: function(response) {

                            if (response.success) {
                                markCurrentSessionAsChecked();
                                $('#privacy-policy-modal').modal('hide');

                                if (typeof toastr !== 'undefined') {
                                    toastr.success('Termos aceitos com sucesso!');
                                }
                            } else {
                                showError(response.message || 'Erro ao aceitar os termos');
                            }
                        },
                        error: function(xhr) {
                            let message = 'Erro ao processar sua solicitação. Tente novamente.';
                            if (xhr.responseJSON && xhr.responseJSON.message) {
                                message = xhr.responseJSON.message;
                            }
                            showError(message);
                        },
                        complete: function() {
                            $('#privacy-loading').hide();
                            $('#acceptPrivacyBtn').prop('disabled', false);
                        }
                    });
                });
            } catch (e) {
                console.error('❌ Erro ao mostrar modal:', e.message);
            }
        }, 300);
    }

    function showError(message) {
        console.warn('⚠ Erro:', message);
        $('#privacy-error').text(message).show();
    }

    $(document).ready(function() {
        setTimeout(function() {
            if (isUserLoggedIn()) {
                checkPrivacyAcceptance();
            }
        }, 1000);
    });
};
